import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { PaymentReceiptUseViewStore } from "../../store";
import { PaymentReceiptUseView } from "../view/PaymentReceiptUseView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type PaymentReceiptUseModalContentProps = {
  entityId: string;
  mode: "view" | "update";
  onClose: () => void;
};

export const PaymentReceiptUseModalContent: React.FC<PaymentReceiptUseModalContentProps> =
  observer(({ entityId, mode, onClose }) => {
    const rootStore = useRootStore();
    const initializedRef = useRef<string | null>(null);

    const storeInfo = useMemo(() => {
      // Default to view mode
      const s = new PaymentReceiptUseViewStore(rootStore);
      s.isModalMode = true;
      return { store: s, type: "view" as const };
    }, [rootStore]);

    useEffect(() => {
      if (entityId && initializedRef.current !== entityId) {
        initializedRef.current = entityId;
        storeInfo.store.initialize({ id: entityId });
      }
    }, [entityId, storeInfo]);

    useEffect(() => {
      return () => {
        storeInfo.store.destroy();
      };
    }, [storeInfo]);

    const store = storeInfo.store;
    if (store.status === "processing" || store.status === "uninitialized") {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Box sx={{ p: 2 }}>
        {storeInfo.type === "view" && (
          <PaymentReceiptUseView
            paymentReceiptUseViewStore={
              storeInfo.store as PaymentReceiptUseViewStore
            }
          />
        )}
      </Box>
    );
  });
